import { createAsyncThunk } from '@reduxjs/toolkit';
import activityApi from '~/apis/activity';
import { GET_ACTIVITY } from '~/utils/constants/actionType';
import { IParamsActivity } from '~/utils/interface/activity';

export const handleGetActivity = createAsyncThunk<any, IParamsActivity>(
  GET_ACTIVITY,
  async (params: IParamsActivity, { rejectWithValue }) => {
    try {
      const res = await activityApi.getActivity(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
